import './BetaRibbon.less';

const BetaRibbon = () => <div className="__BetaRibbon__">Beta</div>;

export default BetaRibbon;
